<template>
  <div>
    <Header>
      <template v-slot:title>
        <span v-if="whitelabel === 'Blackstone'">
          {{ $t("add-new-live-account") }}
        </span>
        <span v-else>
          {{ $t("open-live-account") }}
        </span>
      </template>
    </Header>
    <!-- BR#67 Sunny 10/04/2025 Redirecting to live application form for icmmu -->
    <div class="rounded-md min-h-screen">
      <div class="border-t border-gray-200">
        <div class="flex flex-col">
          <div class="align-middle inline-block min-w-full">
            <div class="border-b border-gray-200">
              <div
                v-if="get_signup_data.step_meta"
                class="max-w-3xl mx-auto min-h-screen"
              >
                <div class="mt-10 pb-10">
                  <Form
                    v-for="(step, index) in get_signup_data.step_meta"
                    v-if="index === $store.getters.show_next_step"
                    :id="index"
                    :key="index"
                    :demo-form="false"
                    :forms="get_signup_data.actions.GET.fields"
                    :numberOfSteps="get_signup_data.step_meta.length - 1"
                    :open-live-form="true"
                    :step="step"
                    :tradingPlatforms="filteredTradingPlatforms"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Logout Confirmation Modal -->
    <div
      v-if="showLogoutConfirm"
      class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
    >
      <div class="bg-white p-6 rounded-lg shadow-xl w-96 text-center border-t-4 border-blue-600">
        <!-- Redirecting state -->
        <div v-if="isConfirming" class="flex flex-col items-center">
          <svg
            class="animate-spin h-16 w-16 text-blue-600 mb-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8z"
            ></path>
          </svg>
          <p class="text-blue-600 font-bold text-lg">
            {{ $t("Redirecting to live application form...") }}
          </p>
        </div>

        <!-- Confirmation question -->
        <div v-else>
          <p class="text-lg font-semibold mb-4 text-blue-700">
            {{ $t("You will be redirected to the Application Submission page to request for an Open Live Account. Do you wish to proceed?") }}
          </p>
          <div class="flex justify-center gap-4">
            <button
              @click="confirmLogout"
              class="bg-red-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
            >
              {{ $t("Yes") }}
            </button>
            <button
              @click="cancelLogout"
              class="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-blue-700 transition"
            >
              {{ $t("Cancel") }}
            </button>
             <!-- BR#67 end -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Form from "@/views/register/Form";
import { mapGetters } from "vuex";
import Header from "@/components/Header";

export default {
  components: {
    Form,
    Header,
  },
  data() {
    return {
      isLoading: false,
      showLogoutConfirm: false, // BR#67 Sunny 10/04/2025 Redirecting to live application form for icmmu
      isConfirming: false, // BR#67 Sunny 10/04/2025 Redirecting to live application form for icmmu
      whitelabel: process.env.VUE_APP_WHITELABEL,
    };
  },
  computed: {
    ...mapGetters(["get_trading_platforms", "get_signup_data"]),
    lang() {
      return this.$store.getters.get_lang;
    },
    filteredTradingPlatforms() {
      const platforms = this.get_trading_platforms;
      if (this.whitelabel === "ICMTrader") {
        //   take just 1st platform
        const mt4Platforms = platforms.filter(
          (platform) => platform.backend.type === "MT4"
        );
        const removedMT4 = platforms.filter(
          (platform) => platform.backend.type !== "MT4"
        );

        // add 1st MT4 platform to the list
        return [...removedMT4, mt4Platforms[0]];
      }
      if (this.whitelabel === "ICMMU") {
        const mt4Platforms = platforms.filter(
          (platform) => platform.backend.type === "MT4"
        );

        if (mt4Platforms.length >= 2) {
          return platforms.filter(
            (platform) =>
              platform.backend.type !== "MT4" ||
              platform.backend.name === "MT4 ICMMU 3"
          );
        }
      }

      // if (this.whitelabel === "ICMSC") {
      //   const mt4Platforms = platforms.filter(
      //     (platform) => platform.backend.type === "MT4"
      //   );

      //   if (mt4Platforms.length >= 2) {
      //     return platforms.filter(
      //       (platform) =>
      //         platform.backend.type !== "MT4" ||
      //         platform.backend.name === "MT4 ICMMU 3"
      //     );
      //   }
      // }

      return platforms;
    },
    
  },

  watch: {
    lang() {
      if (this.whitelabel === "TradeCoreUK") {
        this.$store
          .dispatch("set_signup_data_open_live_account_with_whitelabel")
          .then(() => {
            this.isLoading = false;
          });
      } else {
        this.$store.dispatch("set_signup_data_open_live_account").then(() => {
          this.isLoading = false;
        });
      }
    },
  },
  beforeCreate() {
    if (!localStorage.getItem("step")) {
      localStorage.setItem("step", "0");
    }
  },
  // BR#67 Sunny 10/04/2025 Redirecting to live application form for icmmu
  methods: {
    requestLogout() {
      this.showLogoutConfirm = true;
    },
    cancelLogout() {
      this.showLogoutConfirm = false;
      this.$router.push("/");
    },
    confirmLogout() {
      this.isConfirming = true;

      setTimeout(() => {
        this.isConfirming = false;
        this.showLogoutConfirm = false;

        this.$store.dispatch("logout").then(() => {
          const url = process.env.VUE_APP_API_URL.includes("dev.")
            ? "https://dev-website.anttix.app/auth/login"
            : "https://vcgmarkets.com/auth/login";

          if (this.whitelabel === "VCGMarkets") {
            return window.open(url, "_self");
          }

          if (this.$route.path.includes("/ib")) {
            this.$router.push("/ib/login");
          } else {
            this.$router.push("/accounts");
          }
        });
      }, 5000);
    },
  },
  // BR#67 end

  created() {
    this.isLoading = true;
    // BR#67 Sunny 10/04/2025 Redirecting to live application form for icmmu
    //BR#52 mbeng 07/08/2025 Redirecting to live application form for icmsc
    if (["ICMMU", "ICMVC","ICMSC"].includes(this.whitelabel)) {
      this.requestLogout();
      return;
    }
    // BR#67 end

    if (this.whitelabel === "TradeCoreUK") {
      this.$store
        .dispatch("set_signup_data_open_live_account_with_whitelabel")
        .then(() => {
          this.isLoading = false;
        });
    } else {
      this.$store.dispatch("set_signup_data_open_live_account").then(() => {
        this.isLoading = false;
      });
    }

    this.$store.dispatch("upgrade_trading_platforms").then(() => {
      this.isLoading = false;
    });

    // if (Cookie.get('x-tracking-id')) {
    //   this.$store.dispatch('display_trading_platforms_tracking_links').then(() => {
    //     this.isLoading = false
    //   })
    // } else {
    //   this.$store.dispatch('upgrade_trading_platforms').then(() => {
    //         this.isLoading = false
    //       }
    //   )
    // }

    // if (Cookie.get('x-tracking-id')) {
    //   this.$store.dispatch('display_trading_platforms_tracking_links').then(() => {
    //     this.isLoading = false
    //   })
    // } else {
    //   this.$store.dispatch('display_trading_platforms').then(() => {
    //         this.isLoading = false
    //       }
    //   )
    // }
  },
};
</script>
